<template>
  <li
    v-for="link in links"
    class="list-none select-none"
    :class="link?.className"
    :id="link?.itemId"
    :key="link.name"
  >
    <sidebar-button
      class="hover:bg-won-green-light hover:won-color-green"
      v-tooltip="{ content:link.title, delay: { show: collapsed ? 500 : 999999, hide: 100 } }"
      :active="link?.isActive ? link.isActive() : activeRoute === link.name"
      :collapsed="collapsed"
    >
      <div
        v-if="link?.isExternalRoute"
        class="flex items-center w-full h-10 py-0 px-2.5"
        @click="() => externalLinkHandler(link.name)"
      >
        <span v-if="link?.icon" v-html="link.icon" ></span>
        <div
          v-if="!collapsed"
          class="text-sm font-medium ml-1 whitespace-nowrap"
          v-text="link.title"
        />
      </div>

      <div
          v-tooltip="{ content: link?.disabled ? 'Under Maintenance' : '', placement: 'top' }"
          @click="() => navigateTo(link)"
          :class="[
              link?.disabled ? 'opacity-50' : 'opacity-100',
              !collapsed || 'justify-center'
          ]"
          class="flex items-center w-full h-10 px-2.5"
          v-else
      >
        <span v-if="link?.icon" v-html="link.icon"/>
          
        <span
          v-if="!collapsed"
          :class="['text-sm font-medium ml-1 whitespace-nowrap']"
          v-text="link.title"
        />
      </div>

      <div
        v-if="link?.items?.length && !collapsed"
        class="flex items-center pr-2.5"
        @click="() => updateVisibleSubMenusHandler(link.name)"
      >
        <ChevronDownIcon
          class="size-4 text-won-gray-blue"
          :class="visibleSubMenu.has(link.name) && '-rotate-180'"
        />
      </div>
    </sidebar-button>

    <div
      class="flex flex-col gap-0.5 mt-0.5"
      :class="{'ml-3': !collapsed}"
      v-if="link?.items?.length && visibleSubMenu.has(link.name)"
    >
      <sidebar-menu
        :activeRoute="activeRoute"
        :links="link?.items"
        :collapsed="collapsed"
      />
    </div>
  </li>
</template>

<script setup>
import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia';
import { useRouter } from "vue-router";
import { setAuthState } from "../composables/auth";

import SidebarButton from './sidebar-button';
import SidebarMenu from './sidebar-menu';

import { ChevronDownIcon } from "@heroicons/vue/24/outline";
import { useAuthPopupStore } from "../store/auth-popup.store";

const props = defineProps({
    activeRoute: {
        type: String,
        required: true
    },
    collapsed: {
        type: Boolean,
        default: false
    },
    links: {
        type: Array,
        default: []
    }
})

const router = useRouter();
const authPopupStore = useAuthPopupStore();
const { isAuthenticated } = setAuthState();
const visibleSubMenu = ref(new Set());

const navigateTo = (link) => {
    const { name, params, disabled, allowAnonymous } = link;
    
    if(!isAuthenticated() && allowAnonymous === false) {
        authPopupStore.setShowAuthPopup();
        return;
    }
    
    if(disabled) return;

    router.push({ name, params });
}

const updateVisibleSubMenusHandler = (menu) => {
	if(visibleSubMenu.value.has(menu)){
		visibleSubMenu.value.delete(menu);
	}else{
		visibleSubMenu.value.add(menu);
	}
}

const externalLinkHandler = (url) => {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';

  document.body.appendChild(link);

  link.click();
  link.remove();
}

watch(() => props.activeRoute, val => {
    visibleSubMenu.value = ['resumes.edit', 'resume-tool'].includes(val) ? new Set(['resumes']) : new Set()
}, {immediate:true})
</script>
